import { encodeEscPosChars, ESC_POS_CUT, ESC_POS_PROLOGUE } from './escposCharset';

/** ESC/POS mínimo desde texto plano (comandas, precuenta). */
export function encodeEscPosPlainText(text: string): Uint8Array {
  const bytes: number[] = [...ESC_POS_PROLOGUE];
  bytes.push(...encodeEscPosChars(text));
  if (!text.endsWith('\n')) bytes.push(0x0a);
  bytes.push(...ESC_POS_CUT);
  return Uint8Array.from(bytes);
}
